import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Alert, Box, CircularProgress, Stack, Typography } from '@mui/material';

import { completeOidcLogin } from './grampsAuth';
import { getDefaultTreeName } from './treeName';

export function OidcCompletePage() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void completeOidcLogin().then((token) => {
      if (cancelled) return;
      if (!token) {
        setErrorMessage("La connexion avec Google a échoué. Réessayez depuis la page d'accueil.");
        return;
      }
      navigate(`/${encodeURIComponent(getDefaultTreeName())}`, { replace: true });
    });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      <Stack spacing={2} sx={{ alignItems: 'center' }}>
        {errorMessage
          ? <Alert severity="error">{errorMessage}</Alert>
          : <>
            <CircularProgress />
            <Typography color="text.secondary">Connexion en cours…</Typography>
          </>}
      </Stack>
    </Box>
  );
}
